import axios, { axiosNT } from '../../../services/axios';

const byId = (id: string) => axios.get(`/user/userDetail/${id}`)
  .then((res: any) => Promise.resolve(res.responseObject));

const activityLog = (limit: number = 0, skip: number = 0) => axiosNT.get(`/activityLog?limit=${limit}&skip=${skip}`)
  .then((res: any) => Promise.resolve(res.responseObject));

export default {
  byId,
  activityLog,
}